<template>
  <div>
    <div class="loading" v-show="loading">
      <i class="fa fa-spinner fa-spin"></i>
      <span>{{ $t('provider.notes.loading') }}</span>
    </div>

    <div class="notes-type" v-show="!loading">
      <label>Type:</label>
      <select v-model="notesType">
        <option value="notes">General</option>
        <option value="availability">Availability</option>
      </select>
    </div>

    <div class="empty-state" v-show="notes.length === 0 && !loading">
      <i class="fa fa-address-card fa-4x"></i>
      <span>{{ $t('provider.notes.emptyState') }}</span>
    </div>

    <div class="note" v-for="note in notes" :key="note.id">
      <div class="user">
        <div class="img-holder">
          <img :src="note.picture" />
        </div>
        <span class="name">{{ note.name }}</span>
        <span class="date">{{ note.date }}</span>
      </div>

      <div class="note-content">
        <div class="arrow"></div>
        <p v-html="note.message"></p>
        <div class="actions">
          <div v-if="adminId === note.userId">
            <span @click="editNote(note)">{{ $t('rsvpDetails.notes.edit') }}</span> |
            <span @click="deleteNote(note)">{{ $t('rsvpDetails.notes.delete') }}</span>
          </div>
          <label v-bind:class="['status', note.status]">{{ note.status }}</label>
        </div>
      </div>

      <div :class="{'delete-block':true, 'show':noteDeleteId === note.id}">
        <div :class="{'content':true, 'disabled':deleteLoading}">
          <p>
            {{ $t('rsvpDetails.notes.deleteMessage') }}
            <span v-show="!!deleteMessage">
              <br /> {{ deleteMessage }}
            </span>
          </p>
          <a class="button cta warning small" @click="hideDelete">{{ $t('rsvpDetails.notes.no') }}</a>
          <a class="button cta success small" @click="deleteConfirm(note.id)">
            <span v-show="!deleteLoading">{{ $t('rsvpDetails.notes.yes') }}</span>
            <i class="fa fa-spinner fa-spin fa-fw" v-show="deleteLoading"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="load-more" v-if="!endOfResult && !loading" @click="getNotes">
      Load More
    </div>
  </div>
</template>

<script>
import ApiProviderNotes from '../../modules/api/provider/notes'

export default {
  name: 'notes',
  props: ['active'],
  data () {
    return {
      loading: false,
      deleteLoading: false,
      deleteMessage: '',
      notesType: 'notes',
      loaded: '',
      endOfResult: false
    }
  },
  computed: {
    provId () { return this.$route.params.id },
    notes () {
      let notesList = this.$store.state.provider.notes.list
      if (this.notesType === 'notes') {
        return notesList.filter(x => x.status !== 'availability')
      }
      return notesList.filter(x => x.status === 'availability')
    },
    notesAvailability () { return this.$store.state.provider.notes.list.filter(x => x.status === 'availability') },
    isMax () { return this.$store.state.provider.notes.isMax },
    adminId () { return this.$store.state.session.user.id },
    noteDeleteId () { return this.$store.state.provider.notes.noteDeleteId }
  },
  methods: {
    init () {
      let self = this

      self.$store.commit('provider/resetNotes')
      self.$store.commit('provider/setNotesIsMax', false)
      self.$store.commit('provider/setNotesPage', 0)

      self.getNotes()
    },
    getNotes () {
      let self = this
      if (self.isMax || self.loading) { return }

      self.loading = true
      ApiProviderNotes.getNotes(self, self.provId, function (res) {
        self.loading = false
        if (res.list.length < self.$store.state.provider.notes.pageSize) self.endOfResult = true
      })
    },
    editNote (value) {
      this.$store.commit('reservationNotes/show', {
        noteId: value.id,
        notes: value.message,
        noteStatus: value.status,
        isProv: true
      })
    },
    deleteNote (value) {
      this.$store.commit('provider/setNoteDeleteId', value.id)
    },
    hideDelete () {
      this.$store.commit('provider/setNoteDeleteId', 0)
    },
    deleteConfirm (noteId) {
      let self = this
      self.deleteLoading = true
      self.deleteMessage = ''
      ApiProviderNotes.deleteNote(self, noteId, function (res) {
        if (res.error) {
          self.deleteMessage = res.error.msg
        }
        self.deleteLoading = false
      })
    }
  },
  watch: {
    provId: function (value) {
      this.endOfResult = false
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId
        this.init()
      }
    },
    active (val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId
        this.init()
      }
    }
  },
  mounted () {
    // this.init()
  }
}
</script>

<style lang="scss" scoped>
$cta-link: #0D79F2;
.loading{
  text-align: center;
  padding: 30px;
  font-size: 18px;

  .fa{
    margin-right: 5px;
    color: #555;
  }
  span{ color: #888; }
}

.notes-type{
  text-align: right;
  margin-bottom: 10px;
  
  label{
    font-size: 14px;
    font-weight: 600;
    margin-right: 3px;
    color: #888;
  }
  select{
    width: 110px;
    outline: none;
  }
}

.empty-state{
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa{
    display: block;
    margin-bottom: 5px;
    color: #ddd;
  }
}

.note{
  display: flex;
  padding: 10px 20px;
  position: relative;
}

.user{
  text-align: center;
  width: 170px;
  padding: 0 10px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  z-index: 1;

  .img-holder{
    width: 75px;
    height: 75px;
    border-radius: 100%;
    overflow: hidden;
    display: inline-block;
  }
  span{ display: block; }
  .name{
    font-weight: 600;
    font-size: 14px;
    color: #555;
  }
  .date{
    font-size: 11px;
    color: #999;
  }
}

.note-content{
  background: #f5f5f5;
  padding: 15px;
  display: inline-block;
  width: calc(100% - 170px);
  /*min-height: 100px;*/
  position: relative;
  z-index: 2;
  border-radius: 2px;
  box-shadow: 0 0 3px 1px rgba(0,0,0, .2);

  .arrow{
    position: absolute;
    z-index: 2;
    top: 30px;
    right: 100%;
    margin-right: -20px;
    width: 20px;
    height: 20px;
    background: #f5f5f5;
    box-shadow: -2px 2px 1px rgba(0,0,0, .15);
    transform: translate(-50%, 0) rotate(45deg);
  }
  .status{
    font-size: 10px;
    font-weight: 600;
    padding: 2px 7px;
    color: #fff;
    text-transform: uppercase;
    border-radius: 4px;
    font-style: italic;
    float: left;

    &.resolved{ background: #26D97A }
    &.investigation{ background: #F25E0D }
    &.new{ background: #F20D0D }
    &.availability{ background: #ab11e7 }
  }
  p{
    position: relative;
    z-index: 3;
    font-size: 13px;
    margin: 0;
    color: #555;
    min-height: 60px;
    word-wrap: break-word;
  }
  .actions{
    text-align: right;
    font-size: 12px;
    margin-top:10px;
    font-weight: 600;

    div{ display: inline-block; }
    span{
      color: $cta-link;
      display: inline-block;
      margin: 0 2px;
      cursor: pointer;
    }
  }
}

.delete-block{
  position: absolute;
  top: 50%;
  right: 0;
  width: 100%;
  height: 0%;
  visibility: hidden;
  z-index: 2;
  text-align: center;
  overflow: hidden;
  transition: background .2s, height .2s, top .2s;

  .content{
    display: none;
    p{
      color: #fff;
      font-weight: 600;
    }
    .button{
      min-width: 100px;
      margin: 0 5px;
      display: inline-block;
    }
    &.disabled .button{
      opacity: .5;
      cursor: default;
      font-weight: 100;
      color: #f00;
    }
  }
  &.show{
    visibility: visible;
    background: rgba(0,0,0, .8);
    height: 100%;
    top: 0;

    .content{ display: block; }
  }
}

.load-more{
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #555;
  cursor: pointer;
  background: #efefef;
  margin: 20px auto 10px;
  font-weight: 600;
  width: 40%;
  border-radius: 4px;

  &:hover{
    background: #e0e0e0;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/Notes.vue